import React from "react";
import { routeNames } from "utils/routeNames";

const Home = React.lazy(() => import("site/app/pages/Home"));
const AboutUs = React.lazy(() => import("site/app/pages/About"));
const Guide = React.lazy(() => import("site/app/pages/Guide"));

export const siteRoutes: {
  path: string;
  Component: React.LazyExoticComponent<() => JSX.Element>;
}[] = [
  {
    path: routeNames.home,
    Component: Home,
  },
  {
    path: routeNames.about,
    Component: AboutUs,
  },
  {
    path: routeNames.guide,
    Component: Guide,
  },
];



